import { TABS_INDICES } from "@notifications/constants/notifications.constants";
import { StoreNotification } from "@notifications/models/store-notification";

export class NotificationsState {
    public readonly isShowOnlyUnviewedNotifications: boolean = false;
    public readonly notifications: StoreNotification[] = [];
    public readonly appointmentsVisualizationAllowed: boolean = true;
    public readonly activeTabIndex = TABS_INDICES.ALL;
}